var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8School(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.091,
    height: 27.369,
    viewBox: "0 0 36.091 27.369",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-school",
    transform: "translate(-1 -8.975)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34463",
    "data-name": "Path 34463",
    d: "M37,18.054H2l1.11-1.87H34.115l-3.7-6.212h1.772Z",
    transform: "translate(-0.453 -0.452)",
    fill: "#e71868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34464",
    "data-name": "Path 34464",
    d: "M36.544,18.151h-35a.547.547,0,0,1-.47-.826L5.884,9.242a.547.547,0,0,1,.47-.267H31.737a.547.547,0,0,1,.47.267l4.807,8.082a.547.547,0,0,1-.47.826ZM2.508,17.057H35.583l-4.157-6.989H6.665Z",
    transform: "translate(0)",
    fill: "#e71868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34465",
    "data-name": "Path 34465",
    d: "M36.052,43.042H6.8a.547.547,0,0,1-.547-.547V24.3a.547.547,0,0,1,.547-.547H36.052a.547.547,0,0,1,.547.547V42.495A.547.547,0,0,1,36.052,43.042ZM7.344,41.948H35.505v-17.1H7.344Z",
    transform: "translate(-2.379 -6.698)",
    fill: "#e71868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34466",
    "data-name": "Path 34466",
    d: "M36.544,58.119h-35a.547.547,0,0,1,0-1.094h35a.547.547,0,0,1,0,1.094Z",
    transform: "translate(0 -21.775)",
    fill: "#e71868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34467",
    "data-name": "Path 34467",
    d: "M16.171,34.459H11.8a.547.547,0,0,1-.547-.547V29.3a.547.547,0,0,1,.547-.547h4.375a.547.547,0,0,1,.547.547v4.61A.547.547,0,0,1,16.171,34.459Zm-3.828-1.094h3.281V29.849H12.344Z",
    transform: "translate(-4.645 -8.964)",
    fill: "#e71868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34468",
    "data-name": "Path 34468",
    d: "M33.921,34.459H29.547A.547.547,0,0,1,29,33.912V29.3a.547.547,0,0,1,.547-.547h4.375a.547.547,0,0,1,.547.547v4.61A.547.547,0,0,1,33.921,34.459Zm-3.828-1.094h3.281V29.849H30.094Z",
    transform: "translate(-12.689 -8.964)",
    fill: "#e71868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34469",
    "data-name": "Path 34469",
    d: "M51.671,34.459H47.3a.547.547,0,0,1-.547-.547V29.3a.547.547,0,0,1,.547-.547h4.375a.547.547,0,0,1,.547.547v4.61A.547.547,0,0,1,51.671,34.459Zm-3.828-1.094h3.281V29.849H47.844Z",
    transform: "translate(-20.732 -8.964)",
    fill: "#e71868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34470",
    "data-name": "Path 34470",
    d: "M16.171,48.508H11.8a.547.547,0,0,1-.547-.547V43.35A.547.547,0,0,1,11.8,42.8h4.375a.547.547,0,0,1,.547.547v4.611A.547.547,0,0,1,16.171,48.508Zm-3.828-1.094h3.281V43.9H12.344Z",
    transform: "translate(-4.645 -15.33)",
    fill: "#e71868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34471",
    "data-name": "Path 34471",
    d: "M51.671,48.508H47.3a.547.547,0,0,1-.547-.547V43.35A.547.547,0,0,1,47.3,42.8h4.375a.547.547,0,0,1,.547.547v4.611A.547.547,0,0,1,51.671,48.508Zm-3.828-1.094h3.281V43.9H47.844Z",
    transform: "translate(-20.732 -15.33)",
    fill: "#e71868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34472",
    "data-name": "Path 34472",
    d: "M34.494,45.969v5.282H28.73V45.969a2.882,2.882,0,1,1,5.764,0Z",
    transform: "translate(-12.566 -15.456)",
    fill: "#e71868"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8School);
export default __webpack_public_path__ + "static/media/icons8-school.bd9cb5ec8107c183463befb7368615bf.svg";
export { ForwardRef as ReactComponent };